import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { logIn, fetch, setTema, resetAllDadosPesq } from "../actions";
import { IoMdMoon } from "react-icons/io";
import { FaSun } from "react-icons/fa";
import { Tag, Divider } from "antd";
import dayjs from "dayjs";
import MenuPadrao from "../containers/Menu/Menu";
import { useHistory } from "react-router-dom";
import formatarData from "../Utils/formatarData";
import BtnAtualizarDados from "./BtnAtualizarDados";
import ModalDevConfig from "./ModalDevConfig";

const tagStyle = { margin: "0 10px", padding: "4px 10px", borderRadius: 3, fontSize: 12, fontWeight: "bold" };

function Header({ online, ...props }) {
  const [data, setData] = useState(null);
  const [showDevConfig, setShowDevConfig] = useState(false);
  const history = useHistory();
  const ambiente = props.auth.ambiente;
  const dtSistema = props.devConfig?.find(x => x.nome == "dataSistemaDev")?.valor;

  const toggleTema = () => props.setTema(props.tema.isCustom ? "THEME_CUSTOM" : "THEME_DEFAULT", props.tema, !props.tema.isDark);

  useEffect(() => setData(formatarData(dayjs(props.dtUltimaAtualizacao)).DATAHORASEGUNDOS), []);

  const fmtStr = (str, maxSize) => str?.length > maxSize ? str.substring(0, maxSize) + "..." : str;
  const labelEmp = props.auth?.empresa?.fantasia || props.auth?.empresa?.razaoSocial;

  return <>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 10px", zIndex: 1000 }} className="background-color-menu box-shadow-padrao">
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ cursor: "pointer", userSelect: "none", marginRight: 10 }} onClick={() => history.push("/")}>
          <span className="font-color-menu" style={{ fontSize: "1.2em", display: "inline", padding: 0 }}>{!!props.tema?.nome ? props.tema?.nome : "PDV"}</span>
        </div>

        {(ambiente != "Prod" || !props.isProducao) && <Tag onClick={() => setShowDevConfig(true)} color="#f50" style={{ marginLeft: 10, cursor: "pointer" }}>AMBIENTE: {ambiente}{(!props.isProducao && ambiente == "Prod") ? " Em homologação" : ""} {(!!dtSistema && ambiente != "Prod") ? formatarData(dtSistema).DATA : ""}</Tag>}
        <div className="font-color-menu" style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
          <span title="Última atualização">{data}</span>
          {online && <BtnAtualizarDados onAtualizar={dt => {
            props.resetAllDadosPesq();
            setData(formatarData(dayjs(dt)).DATAHORASEGUNDOS);
          }} />}

          <span style={{ marginLeft: !online && 10 }} className="font-color-menu">
            <b>Status: {online}</b>
          </span>
          {online ? (<Tag color="success" style={tagStyle}>Online</Tag>) : <Tag color="error" style={tagStyle}>Offline</Tag>}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginTop: 5 }}>
        <div style={{ display: "flex", alignItems: "center", marginRight: 20, marginTop: -5 }}>
          {(props.tema.isCustom ? props.tema.escuro : true) && <>
            {props.tema.isDark ?
              <IoMdMoon style={{ cursor: "pointer" }} className="font-color-menu" size={21} onClick={toggleTema} /> :
              <FaSun style={{ cursor: "pointer" }} className="font-color-menu" size={20} onClick={toggleTema} />}
          </>}
        </div>
        <div>
          <MenuPadrao />
          <Divider type="vertical" style={{ height: 50 }} />
        </div>
        <div style={{ marginBottom: 5 }} className="info-menu" >
          <span className="font-color-menu" style={{ marginBottom: 5, display: "block" }} title={labelEmp}><b className="font-color-menu">Empresa: </b>{`${fmtStr(labelEmp, 25)} - ${(props.auth?.empresa?.cnpj || "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}`}</span>
          <span className="font-color-menu" style={{ textAlign: "end" }} title={props.auth.user}><b>Operador:</b> {fmtStr(props.auth.user, 15)}</span>
        </div>
      </div>
    </div>

    {ambiente != "Prod" && <ModalDevConfig visible={showDevConfig} onClose={() => setShowDevConfig(false)} />}
  </>;
}

const mapStateToProps = state => ({ auth: state.auth, tema: state.tema, devConfig: state.devConfig, isProducao: state.dados.isProducao, dtUltimaAtualizacao: state.dados.dtUltimaAtualizacao });

export default connect(mapStateToProps, { logIn, fetch, setTema, resetAllDadosPesq })(Header);
